import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/comment-dots': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M144 208C126.3 208 112 222.3 112 240S126.3 272 144 272 176 257.7 176 240 161.7 208 144 208zM256 208C238.3 208 224 222.3 224 240S238.3 272 256 272 288 257.7 288 240 273.7 208 256 208zM368 208C350.3 208 336 222.3 336 240S350.3 272 368 272 400 257.7 400 240 385.7 208 368 208zM256 32C114.6 32 0 125.1 0 240 0 287.6 19.9 331.2 52.9 366.3 38 405.7 7 439.1 6.5 439.5-0.1 446.5-1.9 456.7 1.9 465.5S14.4 480 24 480C85.5 480 134 454.3 163.1 433.7 192 442.8 223.2 448 256 448 397.4 448 512 354.9 512 240S397.4 32 256 32zM256 400C229.3 400 202.9 395.9 177.6 387.9L154.9 380.7 135.4 394.5C121.1 404.6 101.5 415.9 77.9 423.5 85.2 411.4 92.3 397.8 97.8 383.3L108.4 355.2 87.8 333.4C69.7 314.1 48 282.2 48 240 48 151.8 141.3 80 256 80S464 151.8 464 240 370.7 400 256 400z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/comment-dots.js
// module id = lExu
// module chunks = 144